import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    supplementalWrap: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        // marginTop: 20,
        boxSizing: 'border-box',
      },
      emptySupplemental: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 40,
        color: 'rgba(120, 121, 142, 1)',
        fontSize: 14,
        fontStyle: 'normal',
      },

      /** ~3 comment cards (minHeight + gaps); list scrolls when there are more */
      commentsScrollArea: {
        maxHeight: 158,
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        boxSizing: 'border-box',
        paddingRight: 4,
        WebkitOverflowScrolling: 'touch',
      },
    
      commentCard: {
        minHeight: 70,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        boxSizing: 'border-box',
      },
      commentHeaderRow: {
        height: 24,
        display: 'flex',
        gap: 10,
        justifyContent: 'start',
        alignItems: 'center',
        boxSizing: 'border-box',
      },
      commentAvatar: {
        height: 24,
        width: 24,
        fontSize: 11,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        backgroundColor: '#5398E6',
        color: '#fff',
      },
      commentMeta: {
        display: 'flex',
        gap: 6,
        justifyContent: 'center',
        alignItems: 'center',
      },
      commentAuthor: {
        fontSize: 14,
        fontWeight: 400,
        color: 'rgba(43, 44, 53, 1)',
        fontStyle: 'normal',
        lineHeight: '21px',
      },
      commentDate: {
        fontSize: 14,
        fontWeight: 400,
        color: 'rgba(120, 121, 142, 1)',
        fontStyle: 'normal',
        lineHeight: '17px',
      },
      commentBodyRow: {
        minHeight: 21,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        boxSizing: 'border-box',
      },
      commentBodySpacer: {
        minHeight: 34,
        minWidth: 34,
        boxSizing: 'border-box',
      },
      commentText: {
        fontSize: 14,
        fontWeight: 400,
        color: 'rgba(43, 44, 53, 1)',
        fontStyle: 'normal',
        lineHeight: '17px',
        wordBreak: 'break-word',
      },
    
      addCommentRow: {
        minHeight: 110,
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        gap: 10,
        justifyContent: 'start',
        alignItems: 'flex-start',
      },
      addCommentBox: {
        width: '100%',
        paddingRight: 10,
        position: 'relative',
      },
      addCommentTextarea: {
        width: '100%',
        height: 100,
        fontSize: 12,
        resize: 'none',
        outline: 'none',
        borderRadius: 4,
        border: '1px solid rgba(224, 224, 224, 1)',
        background: 'rgba(250, 250, 250, 1)',
        padding: '5px 8px 6px 8px',
        boxSizing: 'border-box',
        fontFamily: 'inherit',
      },
      addCommentButton: {
        height: 26,
        padding: '3px 10px',
        color: '#fff',
        borderRadius: 4,
        position: 'absolute',
        top: 65,
        right: '4%',
        fontSize: 12,
        textTransform: 'none',
        '&:hover': {
          backgroundColor: 'rgba(2, 136, 209, 1)',
          borderColor: '#3F51B5',
          boxShadow: 'none',
        },
      },
      addCommentButtonActive: {
        backgroundColor: 'rgba(2, 136, 209, 1)',
      },
      addCommentButtonDisabled: {
        backgroundColor: 'rgba(224, 224, 224, 1)',
      },
}));

export default useStyles;